import { render, staticRenderFns } from "./PhotoForm.vue?vue&type=template&id=1b4170ac&scoped=true&"
import script from "./PhotoForm.vue?vue&type=script&lang=js&"
export * from "./PhotoForm.vue?vue&type=script&lang=js&"
import style0 from "./PhotoForm.vue?vue&type=style&index=0&id=1b4170ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4170ac",
  null
  
)

export default component.exports